import './styles.css';
import template from './template.html';

controller.$inject = ['StoresService', '$stateParams', 'adalAuthenticationService', 'UserService', 'Alerts', '$state', '$sce', '$timeout'];

export function controller(StoresService, $stateParams, adalAuthenticationService, UserService, Alerts, $state, $sce, $timeout) {
    const storeId = $stateParams.storeId;
    const vm = this;

    vm.login = adalAuthenticationService.login;
    vm.logout = logout;
    vm.user = adalAuthenticationService.userInfo;
    vm.loading = true;
    vm.userHasAccessToAdminModules = false;
    vm.userHasViewStoreAccess = false;
    vm.state = $state;

    UserService.isInStore(storeId).then(result => vm.user.isInStore = result);
    UserService.isInRole('Admins').then(result => {
        if (result === true) {
            vm.userHasAccessToAdminModules = true;
        } else {
            UserService.isInRole('StoreAdmin').then(result => vm.userHasAccessToAdminModules = result);
        }
    });

    UserService.isInRole('EditStore').then(result => vm.userHasViewStoreAccess = result);

    StoresService.getStore(storeId).then(store => {
        vm.storeName = StoresService.formatStoreName(store);
        StoresService.setStore(store);
        vm.loading = false;
    });

    function logout() {
        Alerts.show({
            title: "Are you sure?",
            text: "Are you sure you want to logout?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#931546",
            confirmButtonText: "Yes, logout.",
            closeOnConfirm: false
        }, adalAuthenticationService.logOut);
    }
}

config.$inject = ['$stateProvider'];

function config($stateProvider) {
    $stateProvider.state('authorised', {
        abstract: true,
        controller: controller,
        controllerAs: 'vm',
        template: template,
        url: '/{storeId:[0-9]{1,4}}',
        requireADLogin: true
    });
}

export default config;


// WEBPACK FOOTER //
// ./src/js/components/authorised/_authorised/index.js